import React from 'react'
import { PlanDetailInterface } from './type'
import { PlanDetail } from './PlanDetail'
import { useTranslation } from 'react-i18next'

type PlanContentsProps = {
  dataContent: PlanDetailInterface[]
  isShowOptions?: boolean
}

export const PlanContents: React.FC<PlanContentsProps> = ({ dataContent, isShowOptions = false }) => {
  const [showMore, setShowMore] = React.useState(false)
  const { t } = useTranslation()

  const groupPlans = dataContent.reduce((groupPlan, plan) => {
    ;(groupPlan[plan['plan_id']] = groupPlan[plan['plan_id']] || []).push(plan)
    return groupPlan
  }, {})

  const planList: PlanDetailInterface[] = React.useMemo(() => {
    const plans = Object.values(groupPlans).map((groupPlan: PlanDetailInterface[]) => {
      return {
        ...groupPlan[0],
        slot: Math.max(...groupPlan.map((plan) => plan.slot)),
      }
    })

    const availablePlans = plans.filter((plan) => plan.slot > 0).sort((a, b) => a.estimation - b.estimation)
    const unavailablePlans = plans.filter((plan) => plan.slot === 0).sort((a, b) => a.estimation - b.estimation)
    return availablePlans.concat(unavailablePlans)
  }, [dataContent])

  const limitShowPlan = 3
  const displayedItems = showMore ? planList : planList.slice(0, limitShowPlan)
  const isDetailPlansScreen = window.location.pathname.includes('plans')

  const handleRenderButtonSeeMore = () => {
    if (isDetailPlansScreen && planList && planList.length > limitShowPlan && !showMore) {
      return (
        <div className="px-4">
          <button
            type="button"
            onClick={() => setShowMore(true)}
            className="all-unset w-full text-center flex items-center gap-1 justify-center border py-2 border-radius-20"
          >
            <span>{t('plan_list.component.see_more')}</span>
            <svg fill="none" height="19" viewBox="0 0 19 19" width="19" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14.75 6.76953L9.5 12.0195L4.25 6.76953"
                stroke="#111827"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              ></path>
            </svg>
          </button>
        </div>
      )
    }
    if (planList && planList.length > 3 && !showMore) {
      return (
        <button
          onClick={() => setShowMore(true)}
          className="mt-3 mb-2 text-center w-full flex justify-center items-center"
          style={{
            color: '#007CFF',
          }}
        >
          +{t('plan_list.component.see_more')}
        </button>
      )
    }
  }

  return (
    <div
      className={`${isDetailPlansScreen ? '' : 'border-b border-[#E5E7EB]'} pb-4 overflow-auto ${
        isDetailPlansScreen ? 'plan-contents-wrapper-detail-page' : 'plan-contents-wrapper'
      }`}
    >
      {displayedItems.map((planDetailItem, index) => {
        const plansGroup = groupPlans[planDetailItem.plan_id] ?? []
        const isMobile = window.innerWidth < 768
        const isShowDetailOption = isShowOptions && index === 0 && isMobile
        return (
          <React.Fragment key={planDetailItem.id}>
            <PlanDetail item={planDetailItem} isShowOptions={isShowDetailOption} plansGroup={plansGroup} />
          </React.Fragment>
        )
      })}
      {handleRenderButtonSeeMore()}
    </div>
  )
}
